/**
 * DesktopMoreMenu translations — Amanah by Zakat.International V2
 *
 * Adds:
 *   • 3 section headers (Calculators / Life & references / Reading)
 *   • 11 menu items (Zakat Calc, Inheritance, Will, Business,
 *     Life & Planning, 60-sec walkthrough, Masjid resources,
 *     Contact, Privacy, Articles, FAQ)
 *
 * Loaded as the 5th lookup tier by `getTranslation()` so a missing
 * language falls back to English automatically.
 *
 * Translated across the 6 highest-traffic locales (en · ar · ur · fr · ms · tr).
 * The 9 remaining languages fall back to English until a follow-up pass.
 */

const en = {
  'v2.menu.section.calculators': 'Calculators',
  'v2.menu.section.lifeRefs': 'Life & references',
  'v2.menu.section.reading': 'Reading',
  'v2.menu.item.zakat': 'Personal Zakat Calculator',
  'v2.menu.item.inheritance': 'Inheritance (Faraid)',
  'v2.menu.item.will': 'Will (Wasiyyah)',
  'v2.menu.item.succession': 'Succession Planning',
  'v2.menu.item.business': 'Business Zakat',
  'v2.menu.item.life': 'Life & Planning',
  'v2.menu.item.walkthrough': '60-sec walkthrough',
  'v2.menu.item.masjid': 'Masjid resources',
  'v2.menu.item.contact': 'Contact',
  'v2.menu.item.privacy': 'Privacy',
  'v2.menu.item.articles': 'Articles',
  'v2.menu.item.faq': 'FAQ',
  'v2.menu.item.learn': 'Learning library',
  'v2.menu.item.legal': 'Country legal guides',
  'v2.menu.item.women': 'Women\u2019s inheritance rights',
  'v2.menu.section.country': 'Country',
  'v2.menu.section.onPage': 'On this page',
};

const ar = {
  'v2.menu.section.calculators': 'الحاسبات',
  'v2.menu.section.lifeRefs': 'الحياة والمراجع',
  'v2.menu.section.reading': 'قراءات',
  'v2.menu.section.country': 'البلد',
  'v2.menu.section.onPage': 'في هذه الصفحة',
  'v2.menu.item.zakat': 'حاسبة الزكاة',
  'v2.menu.item.inheritance': 'الميراث (الفرائض)',
  'v2.menu.item.will': 'الوصية (الوصيّة)',
  'v2.menu.item.succession': 'التخطيط للتركة',
  'v2.menu.item.business': 'زكاة الأعمال',
  'v2.menu.item.life': 'الحياة والتخطيط',
  'v2.menu.item.walkthrough': 'جولة في 60 ثانية',
  'v2.menu.item.masjid': 'موارد المسجد',
  'v2.menu.item.contact': 'تواصل معنا',
  'v2.menu.item.privacy': 'الخصوصية',
  'v2.menu.item.articles': 'المقالات',
  'v2.menu.item.faq': 'الأسئلة الشائعة',
  'v2.menu.item.learn': 'مكتبة التعلّم',
  'v2.menu.item.legal': 'أدلة قانونية للدول',
  'v2.menu.item.women': 'حقوق ميراث المرأة',
};

const ur = {
  'v2.menu.section.calculators': 'کیلکولیٹرز',
  'v2.menu.section.lifeRefs': 'زندگی اور حوالہ جات',
  'v2.menu.section.reading': 'مطالعہ',
  'v2.menu.section.country': 'ملک',
  'v2.menu.section.onPage': 'اس صفحہ پر',
  'v2.menu.item.zakat': 'زکات کیلکولیٹر',
  'v2.menu.item.inheritance': 'وراثت (فرائض)',
  'v2.menu.item.will': 'وصیت',
  'v2.menu.item.succession': 'وراثتی منصوبہ بندی',
  'v2.menu.item.business': 'کاروباری زکات',
  'v2.menu.item.life': 'زندگی اور منصوبہ بندی',
  'v2.menu.item.walkthrough': '60 سیکنڈ کا جائزہ',
  'v2.menu.item.masjid': 'مسجد کے وسائل',
  'v2.menu.item.contact': 'رابطہ',
  'v2.menu.item.privacy': 'رازداری',
  'v2.menu.item.articles': 'مضامین',
  'v2.menu.item.faq': 'اکثر پوچھے گئے سوالات',
  'v2.menu.item.learn': 'مطالعاتی کتب خانہ',
  'v2.menu.item.legal': 'ممالک کے قانونی گائیڈز',
  'v2.menu.item.women': 'خواتین کے وراثتی حقوق',
};

const fr = {
  'v2.menu.section.calculators': 'Calculateurs',
  'v2.menu.section.lifeRefs': 'Vie & références',
  'v2.menu.section.reading': 'Lecture',
  'v2.menu.section.country': 'Pays',
  'v2.menu.section.onPage': 'Sur cette page',
  'v2.menu.item.zakat': 'Calculateur de Zakat',
  'v2.menu.item.inheritance': 'Héritage (Faraid)',
  'v2.menu.item.will': 'Testament (Wasiyyah)',
  'v2.menu.item.succession': 'Planification successorale',
  'v2.menu.item.business': 'Zakat entreprise',
  'v2.menu.item.life': 'Vie & planification',
  'v2.menu.item.walkthrough': 'Visite en 60 s',
  'v2.menu.item.masjid': 'Ressources mosquée',
  'v2.menu.item.contact': 'Contact',
  'v2.menu.item.privacy': 'Confidentialité',
  'v2.menu.item.articles': 'Articles',
  'v2.menu.item.faq': 'FAQ',
  'v2.menu.item.learn': 'Bibliothèque',
  'v2.menu.item.legal': 'Guides juridiques par pays',
  'v2.menu.item.women': 'Droits de succession des femmes',
};

const ms = {
  'v2.menu.section.calculators': 'Kalkulator',
  'v2.menu.section.lifeRefs': 'Kehidupan & rujukan',
  'v2.menu.section.reading': 'Bacaan',
  'v2.menu.section.country': 'Negara',
  'v2.menu.section.onPage': 'Di halaman ini',
  'v2.menu.item.zakat': 'Kalkulator Zakat',
  'v2.menu.item.inheritance': 'Pusaka (Faraid)',
  'v2.menu.item.will': 'Wasiat (Wasiyyah)',
  'v2.menu.item.succession': 'Perancangan pusaka',
  'v2.menu.item.business': 'Zakat Perniagaan',
  'v2.menu.item.life': 'Kehidupan & perancangan',
  'v2.menu.item.walkthrough': 'Lawatan 60 saat',
  'v2.menu.item.masjid': 'Sumber masjid',
  'v2.menu.item.contact': 'Hubungi',
  'v2.menu.item.privacy': 'Privasi',
  'v2.menu.item.articles': 'Artikel',
  'v2.menu.item.faq': 'Soalan Lazim',
  'v2.menu.item.learn': 'Perpustakaan pembelajaran',
  'v2.menu.item.legal': 'Panduan undang-undang negara',
  'v2.menu.item.women': 'Hak pusaka wanita',
};

const tr = {
  'v2.menu.section.calculators': 'Hesap makineleri',
  'v2.menu.section.lifeRefs': 'Yaşam & kaynaklar',
  'v2.menu.section.reading': 'Okuma',
  'v2.menu.section.country': 'Ülke',
  'v2.menu.section.onPage': 'Bu sayfada',
  'v2.menu.item.zakat': 'Zekât Hesaplayıcı',
  'v2.menu.item.inheritance': 'Miras (Feraiz)',
  'v2.menu.item.will': 'Vasiyet (Vasiyye)',
  'v2.menu.item.succession': 'Miras planlaması',
  'v2.menu.item.business': 'İşletme Zekâtı',
  'v2.menu.item.life': 'Yaşam & Planlama',
  'v2.menu.item.walkthrough': '60 sn tanıtım',
  'v2.menu.item.masjid': 'Cami kaynakları',
  'v2.menu.item.contact': 'İletişim',
  'v2.menu.item.privacy': 'Gizlilik',
  'v2.menu.item.articles': 'Makaleler',
  'v2.menu.item.faq': 'SSS',
  'v2.menu.item.learn': 'Öğrenme kütüphanesi',
  'v2.menu.item.legal': 'Ülkelere göre hukuk rehberi',
  'v2.menu.item.women': 'Kadınların miras hakları',
};

const ru = {
  'v2.menu.section.calculators': 'Калькуляторы',
  'v2.menu.section.lifeRefs': 'Жизнь и справочники',
  'v2.menu.section.reading': 'Чтение',
  'v2.menu.item.zakat': 'Калькулятор закята',
  'v2.menu.item.inheritance': 'Наследство (Фараид)',
  'v2.menu.item.will': 'Завещание (Васыя)',
  'v2.menu.item.succession': 'Планирование наследства',
  'v2.menu.item.business': 'Бизнес-закят',
  'v2.menu.item.life': 'Жизнь и планирование',
  'v2.menu.item.walkthrough': 'Обзор 60 сек',
  'v2.menu.item.masjid': 'Ресурсы мечети',
  'v2.menu.item.contact': 'Контакты',
  'v2.menu.item.privacy': 'Приватность',
  'v2.menu.item.articles': 'Статьи',
  'v2.menu.item.faq': 'Ответы',
  'v2.menu.item.learn': 'Учебная библиотека',
  'v2.menu.item.legal': 'Правовые гиды по странам',
  'v2.menu.item.women': 'Права наследования женщин',
  'v2.menu.section.country': 'Страна',
  'v2.menu.section.onPage': 'На этой странице',
};

const hi = {
  'v2.menu.section.calculators': 'कैलकुलेटर',
  'v2.menu.section.lifeRefs': 'जीवन और संदर्भ',
  'v2.menu.section.reading': 'पठन',
  'v2.menu.item.zakat': 'ज़कात कैलकुलेटर',
  'v2.menu.item.inheritance': 'वारिसी (फ़राइद)',
  'v2.menu.item.will': 'वसीयत',
  'v2.menu.item.succession': 'उत्तराधिकार योजना',
  'v2.menu.item.business': 'व्यवसाय ज़कात',
  'v2.menu.item.life': 'जीवन और योजना',
  'v2.menu.item.walkthrough': '60 सेकंड परिचय',
  'v2.menu.item.masjid': 'मस्जिद संसाधन',
  'v2.menu.item.contact': 'संपर्क',
  'v2.menu.item.privacy': 'गोपनीयता',
  'v2.menu.item.articles': 'लेख',
  'v2.menu.item.faq': 'प्रश्नोत्तर',
  'v2.menu.item.learn': 'शिक्षण पुस्तकालय',
  'v2.menu.item.legal': 'देशवार क़ानूनी गाइड',
  'v2.menu.item.women': 'महिलाओं के विरासत अधिकार',
  'v2.menu.section.country': 'देश',
  'v2.menu.section.onPage': 'इस पृष्ठ पर',
};

const bn = {
  'v2.menu.section.calculators': 'ক্যালকুলেটর',
  'v2.menu.section.lifeRefs': 'জীবন ও রেফারেন্স',
  'v2.menu.section.reading': 'পড়া',
  'v2.menu.item.zakat': 'যাকাত ক্যালকুলেটর',
  'v2.menu.item.inheritance': 'উত্তরাধিকার (ফারায়েজ)',
  'v2.menu.item.will': 'ওসিয়ত',
  'v2.menu.item.succession': 'উত্তরাধিকার পরিকল্পনা',
  'v2.menu.item.business': 'ব্যবসা যাকাত',
  'v2.menu.item.life': 'জীবন ও পরিকল্পনা',
  'v2.menu.item.walkthrough': '৬০ সেকেন্ড পরিচিতি',
  'v2.menu.item.masjid': 'মসজিদ রিসোর্স',
  'v2.menu.item.contact': 'যোগাযোগ',
  'v2.menu.item.privacy': 'গোপনীয়তা',
  'v2.menu.item.articles': 'নিবন্ধ',
  'v2.menu.item.faq': 'সাধারণ প্রশ্ন',
  'v2.menu.item.learn': 'শিক্ষা লাইব্রেরি',
  'v2.menu.item.legal': 'দেশ অনুযায়ী আইনি গাইড',
  'v2.menu.item.women': 'নারীর উত্তরাধিকার অধিকার',
  'v2.menu.section.country': 'দেশ',
  'v2.menu.section.onPage': 'এই পৃষ্ঠায়',
};

const ml = {
  'v2.menu.section.calculators': 'കാൽക്കുലേറ്ററുകൾ',
  'v2.menu.section.lifeRefs': 'ജീവിതം & റഫറൻസുകൾ',
  'v2.menu.section.reading': 'വായന',
  'v2.menu.item.zakat': 'സകാത് കാൽക്കുലേറ്റർ',
  'v2.menu.item.inheritance': 'അനന്തരാവകാശം (ഫറാഇദ്)',
  'v2.menu.item.will': 'വസിയ്യത്ത്',
  'v2.menu.item.succession': 'അനന്തരാവകാശ ആസൂത്രണം',
  'v2.menu.item.business': 'ബിസിനസ്സ് സകാത്',
  'v2.menu.item.life': 'ജീവിതം & ആസൂത്രണം',
  'v2.menu.item.walkthrough': '60 സെക്കൻഡ് അവലോകനം',
  'v2.menu.item.masjid': 'പള്ളി വിഭവങ്ങൾ',
  'v2.menu.item.contact': 'ബന്ധപ്പെടുക',
  'v2.menu.item.privacy': 'സ്വകാര്യത',
  'v2.menu.item.articles': 'ലേഖനങ്ങൾ',
  'v2.menu.item.faq': 'ചോദ്യോത്തരം',
  'v2.menu.item.learn': 'പഠന ലൈബ്രറി',
  'v2.menu.item.legal': 'രാജ്യ നിയമ ഗൈഡുകൾ',
  'v2.menu.item.women': 'സ്ത്രീകളുടെ അനന്തരാവകാശം',
  'v2.menu.section.country': 'രാജ്യം',
  'v2.menu.section.onPage': 'ഈ പേജിൽ',
};

const id = {
  'v2.menu.section.calculators': 'Kalkulator',
  'v2.menu.section.lifeRefs': 'Kehidupan & referensi',
  'v2.menu.section.reading': 'Bacaan',
  'v2.menu.item.zakat': 'Kalkulator Zakat',
  'v2.menu.item.inheritance': 'Waris (Faraid)',
  'v2.menu.item.will': 'Wasiat (Wasiyyah)',
  'v2.menu.item.succession': 'Perencanaan waris',
  'v2.menu.item.business': 'Zakat Usaha',
  'v2.menu.item.life': 'Kehidupan & perencanaan',
  'v2.menu.item.walkthrough': 'Tur 60 detik',
  'v2.menu.item.masjid': 'Sumber daya masjid',
  'v2.menu.item.contact': 'Kontak',
  'v2.menu.item.privacy': 'Privasi',
  'v2.menu.item.articles': 'Artikel',
  'v2.menu.item.faq': 'FAQ',
  'v2.menu.item.learn': 'Perpustakaan pembelajaran',
  'v2.menu.item.legal': 'Panduan hukum tiap negara',
  'v2.menu.item.women': 'Hak waris perempuan',
  'v2.menu.section.country': 'Negara',
  'v2.menu.section.onPage': 'Di halaman ini',
};

const fa = {
  'v2.menu.section.calculators': 'ماشین‌حساب‌ها',
  'v2.menu.section.lifeRefs': 'زندگی و مراجع',
  'v2.menu.section.reading': 'خواندنی‌ها',
  'v2.menu.item.zakat': 'ماشین‌حساب زکات',
  'v2.menu.item.inheritance': 'ارث (فرائض)',
  'v2.menu.item.will': 'وصیت',
  'v2.menu.item.succession': 'برنامه‌ریزی وراثت',
  'v2.menu.item.business': 'زکات کسب‌وکار',
  'v2.menu.item.life': 'زندگی و برنامه‌ریزی',
  'v2.menu.item.walkthrough': 'مرور ۶۰ ثانیه',
  'v2.menu.item.masjid': 'منابع مسجد',
  'v2.menu.item.contact': 'تماس',
  'v2.menu.item.privacy': 'حریم خصوصی',
  'v2.menu.item.articles': 'مقالات',
  'v2.menu.item.faq': 'پرسش‌های متداول',
  'v2.menu.item.learn': 'کتابخانه آموزشی',
  'v2.menu.item.legal': 'راهنماهای حقوقی کشورها',
  'v2.menu.item.women': 'حقوق ارث زنان',
  'v2.menu.section.country': 'کشور',
  'v2.menu.section.onPage': 'در این صفحه',
};

const prs = { ...fa };

const sw = {
  'v2.menu.section.calculators': 'Vikokotoo',
  'v2.menu.section.lifeRefs': 'Maisha & marejeleo',
  'v2.menu.section.reading': 'Kusoma',
  'v2.menu.item.zakat': 'Kikokotoo cha Zakat',
  'v2.menu.item.inheritance': 'Urithi (Faraid)',
  'v2.menu.item.will': 'Wasiyyah',
  'v2.menu.item.succession': 'Mipango ya urithi',
  'v2.menu.item.business': 'Zakat ya Biashara',
  'v2.menu.item.life': 'Maisha & mipango',
  'v2.menu.item.walkthrough': 'Ziara ya sekunde 60',
  'v2.menu.item.masjid': 'Rasilimali za msikiti',
  'v2.menu.item.contact': 'Wasiliana',
  'v2.menu.item.privacy': 'Faragha',
  'v2.menu.item.articles': 'Makala',
  'v2.menu.item.faq': 'Maswali',
  'v2.menu.item.learn': 'Maktaba ya kujifunza',
  'v2.menu.item.legal': 'Miongozo ya sheria za nchi',
  'v2.menu.item.women': 'Haki za urithi za wanawake',
  'v2.menu.section.country': 'Nchi',
  'v2.menu.section.onPage': 'Kwenye ukurasa huu',
};

const uz = {
  'v2.menu.section.calculators': 'Kalkulyatorlar',
  'v2.menu.section.lifeRefs': 'Hayot va manbalar',
  'v2.menu.section.reading': 'O\u2018qish',
  'v2.menu.item.zakat': 'Zakot kalkulyatori',
  'v2.menu.item.inheritance': 'Meros (faroiz)',
  'v2.menu.item.will': 'Vasiyat',
  'v2.menu.item.succession': 'Meros rejalashtirish',
  'v2.menu.item.business': 'Biznes zakoti',
  'v2.menu.item.life': 'Hayot va rejalashtirish',
  'v2.menu.item.walkthrough': '60 soniyalik ko\u2018rish',
  'v2.menu.item.masjid': 'Masjid resurslari',
  'v2.menu.item.contact': 'Aloqa',
  'v2.menu.item.privacy': 'Maxfiylik',
  'v2.menu.item.articles': 'Maqolalar',
  'v2.menu.item.faq': 'Savol-javob',
  'v2.menu.item.learn': 'O\u2018quv kutubxonasi',
  'v2.menu.item.legal': 'Davlatlar bo\u2018yicha huquqiy qo\u2018llanmalar',
  'v2.menu.item.women': 'Ayollarning meros huquqlari',
  'v2.menu.section.country': 'Mamlakat',
  'v2.menu.section.onPage': 'Ushbu sahifada',
};

export const translationsV2Menu = { en, ar, ur, fr, ms, tr, ru, hi, bn, ml, id, fa, prs, sw, uz };

export default translationsV2Menu;
